<template>
  <div class="card flex justify-center">
    <Button
      link
      type="button"
      aria-haspopup="true"
      aria-controls="overlay_menu"
      @click="toggle"
    >
      <div class="h-12 w-12 flex overflow-visible items-center justify-center">
        <UserAvatar />
      </div>
      <span class="inline-flex flex-col items-start text-slate-700 ml-2">
        <span class="font-bold">{{ userDisplayName }}</span>
        <span class="text-sm text-slate-500">{{ userTypeDisplay }}</span>
      </span>
    </Button>
    <Menu id="overlay_menu" ref="menu" :model="items" :popup="true" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "~/store/user";
import UserAvatar from "../settings/UserAvatar.vue";

interface MenuItem {
  label: string;
  icon?: string;
  command?: () => void;
}

defineProps<{
  items: MenuItem[];
}>();

const menu = ref();
const userStore = useUserStore();
const { t } = useI18n();

const toggle = (event: Event) => {
  menu.value.toggle(event);
};

const userDisplayName = computed(() => {
  const user = userStore.user;
  if (!user) return t("common.guest");

  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else if (user.first_name) {
    return user.first_name;
  }

  return t("common.profile");
});

const userTypeDisplay = computed(() => {
  const user = userStore.user;
  if (!user || !user.user_type) return t("common.guest");

  if (typeof user.user_type === "string") return user.user_type;
  return user.user_type.label || user.user_type.value || "";
});
</script>
